"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const OsmosysBaseEntity_1 = require("../OsmosysBaseEntity");
const ContentConversion_1 = require("../converter/ContentConversion");
const _1 = require(".");
const EmailList_1 = require("./EmailList");
const EmailSegment_1 = require("./EmailSegment");
const Integration_1 = require("../integrations/Integration");
const auth_1 = require("../auth");
const Workspace_1 = require("../auth/Workspace");
const SalesforceCategory_1 = require("../integrations/EmailServiceProviders/SalesforceCategory");
const integrations_1 = require("../integrations");
// import { SalesforceCategory } from '../integrations/EmailServiceProviders/SalesforceCategory';
let EmailCampaign = class EmailCampaign extends OsmosysBaseEntity_1.OsmosysBaseEntity {
};
tslib_1.__decorate([
    type_graphql_1.Field(() => Workspace_1.Workspace),
    typeorm_1.ManyToOne(() => Workspace_1.Workspace),
    typeorm_1.JoinColumn(),
    tslib_1.__metadata("design:type", Object)
], EmailCampaign.prototype, "workspace", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => auth_1.User, { nullable: true }),
    typeorm_1.ManyToOne(() => auth_1.User, {
        cascade: true,
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], EmailCampaign.prototype, "creatingUser", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => EmailList_1.EmailList, { nullable: true }),
    typeorm_1.ManyToOne(() => EmailList_1.EmailList, {
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], EmailCampaign.prototype, "list", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => EmailList_1.EmailList, { nullable: true }),
    typeorm_1.ManyToOne(() => EmailList_1.EmailList, {
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], EmailCampaign.prototype, "testList", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => EmailSegment_1.EmailSegment, { nullable: true }),
    typeorm_1.ManyToOne(() => EmailSegment_1.EmailSegment, {
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], EmailCampaign.prototype, "segment", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Number, { nullable: true }),
    typeorm_1.RelationId((obj) => obj.segment),
    tslib_1.__metadata("design:type", Number)
], EmailCampaign.prototype, "segmentId", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", Object)
], EmailCampaign.prototype, "name", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", Object)
], EmailCampaign.prototype, "espId", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", Object)
], EmailCampaign.prototype, "espUrl", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => _1.Email, { nullable: true }),
    typeorm_1.ManyToOne(() => _1.Email, {
        cascade: true,
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], EmailCampaign.prototype, "email", void 0);
tslib_1.__decorate([
    typeorm_1.ManyToOne(() => Integration_1.Integration, { nullable: true }),
    tslib_1.__metadata("design:type", Object)
], EmailCampaign.prototype, "emailServiceProvider", void 0);
tslib_1.__decorate([
    typeorm_1.RelationId((obj) => obj.emailServiceProvider),
    tslib_1.__metadata("design:type", Number)
], EmailCampaign.prototype, "emailServiceProviderId", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", Object)
], EmailCampaign.prototype, "fromName", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    class_validator_1.IsEmail(),
    typeorm_1.Column({
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", Object)
], EmailCampaign.prototype, "fromEmail", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    class_validator_1.IsEmail(),
    typeorm_1.Column({
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", Object)
], EmailCampaign.prototype, "replyToEmail", void 0);
tslib_1.__decorate([
    typeorm_1.Column({
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", Object)
], EmailCampaign.prototype, "subjectLine", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [String], { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'simple-array',
    }),
    class_validator_1.IsArray(),
    tslib_1.__metadata("design:type", Object)
], EmailCampaign.prototype, "subjectLines", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", Object)
], EmailCampaign.prototype, "html", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", Object)
], EmailCampaign.prototype, "defaultSubjectLine", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'timestamp',
    }),
    tslib_1.__metadata("design:type", Object)
], EmailCampaign.prototype, "actualSendDateTime", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'timestamp',
    }),
    tslib_1.__metadata("design:type", Object)
], EmailCampaign.prototype, "scheduledSendDateTime", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [ContentConversion_1.ContentConversion]),
    typeorm_1.ManyToMany(() => ContentConversion_1.ContentConversion, conversion => conversion.emailCampaigns),
    typeorm_1.JoinTable(),
    tslib_1.__metadata("design:type", Object)
], EmailCampaign.prototype, "conversions", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => SalesforceCategory_1.SalesforceCategory, { nullable: true }),
    typeorm_1.OneToMany('SalesforceCategory', 'salesforceEmailCampaignSendCategory'),
    typeorm_1.JoinColumn(),
    tslib_1.__metadata("design:type", Object)
], EmailCampaign.prototype, "salesforceSendCategory", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => SalesforceCategory_1.SalesforceCategory, { nullable: true }),
    typeorm_1.OneToMany('SalesforceCategory', 'salesforceEmailCampaignTestSendCategory'),
    typeorm_1.JoinColumn(),
    tslib_1.__metadata("design:type", Object)
], EmailCampaign.prototype, "salesforceTestSendCategory", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => integrations_1.SalesforceSendClassification, { nullable: true }),
    typeorm_1.ManyToOne(() => integrations_1.SalesforceSendClassification),
    tslib_1.__metadata("design:type", Object)
], EmailCampaign.prototype, "salesforceSendClassification", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.RelationId((obj) => obj.salesforceSendClassification),
    tslib_1.__metadata("design:type", Object)
], EmailCampaign.prototype, "salesforceSendClassificationId", void 0);
EmailCampaign = tslib_1.__decorate([
    type_graphql_1.ObjectType(),
    typeorm_1.Entity()
], EmailCampaign);
exports.EmailCampaign = EmailCampaign;
//# sourceMappingURL=EmailCampaign.js.map